var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppDevelopment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 13C15.24 13 13 15.24 13 18C13 20.76 15.24 23 18 23C20.76 23 23 20.76 23 18C23 15.24 20.76 13 18 13ZM17.16 19.27C17.41 19.52 17.41 19.93 17.16 20.19C17.03 20.32 16.87 20.38 16.7 20.38C16.53 20.38 16.37 20.32 16.24 20.19L14.51 18.46C14.26 18.21 14.26 17.8 14.51 17.54L16.24 15.81C16.49 15.56 16.9 15.56 17.16 15.81C17.41 16.06 17.41 16.47 17.16 16.73L15.89 18L17.16 19.27ZM21.48 18.46L19.75 20.19C19.62 20.32 19.46 20.38 19.29 20.38C19.12 20.38 18.96 20.32 18.83 20.19C18.58 19.94 18.58 19.53 18.83 19.27L20.11 18L18.84 16.73C18.59 16.48 18.59 16.07 18.84 15.81C19.09 15.56 19.5 15.56 19.76 15.81L21.49 17.54C21.73 17.8 21.73 18.2 21.48 18.46Z",
    fill: "#063085"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 7.00078V11.4708C21 11.8208 20.66 12.0608 20.34 11.9408C19.23 11.5108 17.99 11.3708 16.69 11.6308C14.09 12.1508 12.02 14.2808 11.59 16.9008C11.33 18.5008 11.65 20.0108 12.38 21.2408C12.58 21.5808 12.34 22.0008 11.95 22.0008H8C4.5 22.0008 3 20.0008 3 17.0008V7.00078C3 4.34078 4.18 2.47078 6.89 2.08078C7.18 2.04078 7.44 2.27078 7.45 2.57078L7.48 3.58078C7.51 5.18078 8.86 6.50078 10.48 6.50078H13.5C15.15 6.50078 16.5 5.15078 16.5 3.50078V2.57078C16.5 2.27078 16.76 2.03078 17.05 2.07078C19.8 2.44078 21 4.32078 21 7.00078Z",
    fill: "#063085"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9996 3V3.5C14.9996 4.32 14.3196 5 13.4996 5H10.4696C9.65963 5 8.98963 4.35 8.96963 3.54L8.95963 3.03C8.93963 2.46 9.38963 2 9.95963 2H13.9996C14.5496 2 14.9996 2.45 14.9996 3Z",
    fill: "#063085"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppDevelopment);
export default __webpack_public_path__ + "static/media/app-development.640a8394389b34a3bb315548f5727df7.svg";
export { ForwardRef as ReactComponent };